function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-94"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.92a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,43.92,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.92,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.28,
    y: 391.92,
    width: 26,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.15,
    y: 389.21,
    width: 45.03,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.28,
    y: 401.21,
    width: 60.79,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.49,
    y: 399.53,
    width: 19.23,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.29,
    y: 399.53,
    width: 55.29,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.05,
    y: 395.31,
    width: 74.47,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.64 295.67 115.06 295.67 111.75 257.44 166.33 257.44 169.64 295.67",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.47 295.67 117.89 295.67 114.57 257.44 169.15 257.44 172.47 295.67",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.35 287.46 123.53 265.65 161.69 265.65 163.51 287.46 125.35 287.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.82,
    y: 295.67,
    width: 7.79,
    height: 86.73,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.65,
    y: 295.67,
    width: 5.41,
    height: 86.73,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.66,
    y: 295.67,
    width: 75.41,
    height: 9.57,
    transform: "translate(338.72 600.91) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.53,
    y: 305.24,
    width: 7.79,
    height: 77.16,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.37,
    y: 305.24,
    width: 5.41,
    height: 77.16,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.07,
    y: 305.24,
    width: 7.79,
    height: 77.16,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.91,
    y: 305.24,
    width: 5.41,
    height: 77.16,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.51,
    y: 305.24,
    width: 7.79,
    height: 77.16,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.35,
    y: 305.24,
    width: 5.41,
    height: 77.16,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.07,
    y: 295.67,
    width: 60.58,
    height: 9.57,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.01,
    y: 82.42,
    width: 226.23,
    height: 129.78,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.83,
    y: 82.42,
    width: 229.45,
    height: 129.78,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.01,
    y: 212.2,
    width: 226.23,
    height: 11.24,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.9,
    y: 212.2,
    width: 229.45,
    height: 11.24,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.13,
    y: 41.05,
    width: 112.85,
    height: 212.52,
    transform: "translate(333.86 -39.25) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.91 203.73 145.59 90.88 169.05 90.88 119.36 203.73 95.91 203.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.22,195.31a.61.61,0,0,1-.61-.61V96.39a.61.61,0,0,1,1.21,0V194.7A.61.61,0,0,1,84.22,195.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.4 203.73 174.09 90.88 183.23 90.88 133.55 203.73 124.4 203.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.85,
    y: 146.77,
    width: 112.85,
    height: 1.08,
    transform: "translate(439.58 -144.97) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.28 103.65 77.05 103.65 76.28 94.17 302.5 94.17 303.28 103.65",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.28 119.18 77.05 119.18 76.28 109.71 302.5 109.71 303.28 119.18",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.28 134.72 77.05 134.72 76.28 125.25 302.5 125.25 303.28 134.72",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.28 150.26 77.05 150.26 76.28 140.78 302.5 140.78 303.28 150.26",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.28 165.8 77.05 165.8 76.28 156.32 302.5 156.32 303.28 165.8",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.28 181.33 77.05 181.33 76.28 171.86 302.5 171.86 303.28 181.33",
    style: {
      fill: "#ebebeb",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.42,
    y: 82.42,
    width: 60.92,
    height: 60.92,
    transform: "translate(791.76 225.75) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.72,
    y: 82.42,
    width: 2.7,
    height: 60.92,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.67,
    y: 90.67,
    width: 44.41,
    height: 44.41,
    transform: "translate(791.76 225.75) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.37,
    y: 102.37,
    width: 21.02,
    height: 21.02,
    transform: "translate(755.63 -87.24) rotate(135)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.43,
    y: 162.52,
    width: 60.92,
    height: 60.92,
    transform: "translate(749.78 385.95) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.73,
    y: 162.52,
    width: 2.7,
    height: 60.92,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.68,
    y: 170.77,
    width: 44.41,
    height: 44.41,
    transform: "translate(749.78 385.95) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.42,
    y: 183.51,
    width: 18.94,
    height: 18.94,
    rx: 6.31,
    transform: "translate(749.78 385.95) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.53,
    y: 253.03,
    width: 15.19,
    height: 125.28,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.64,
    y: 378.31,
    width: 145.86,
    height: 4.09,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.73,
    y: 253.03,
    width: 134.88,
    height: 125.28,
    transform: "translate(750.33 631.34) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.2,326.24H334.13a14.61,14.61,0,0,1,0-29.22H416.2a14.61,14.61,0,0,1,0,29.22ZM334.13,298a13.63,13.63,0,0,0,0,27.26H416.2a13.63,13.63,0,0,0,0-27.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.2,362.59H334.13a14.61,14.61,0,0,1,0-29.22H416.2a14.61,14.61,0,1,1,0,29.22Zm-82.07-28.24a13.63,13.63,0,1,0,0,27.25H416.2a13.63,13.63,0,1,0,0-27.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.55,308.48H362.78a3.06,3.06,0,0,1-3-3.05h0a3.06,3.06,0,0,1,3-3.05h24.77a3.06,3.06,0,0,1,3.05,3.05h0A3.06,3.06,0,0,1,387.55,308.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.2,289.89H334.13a14.61,14.61,0,1,1,0-29.22H416.2a14.61,14.61,0,1,1,0,29.22Zm-82.07-28.24a13.63,13.63,0,1,0,0,27.26H416.2a13.63,13.63,0,0,0,0-27.26Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.55,272.13H362.78a3.06,3.06,0,0,1-3-3.05h0a3.05,3.05,0,0,1,3-3h24.77a3.06,3.06,0,0,1,3.05,3h0A3.06,3.06,0,0,1,387.55,272.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.55,344.82H362.78a3.05,3.05,0,0,1-3-3h0a3.06,3.06,0,0,1,3-3h24.77a3.06,3.06,0,0,1,3.05,3h0A3.06,3.06,0,0,1,387.55,344.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.73,
    y: 246.67,
    width: 137.65,
    height: 6.37,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.56,
    y: 246.67,
    width: 18.17,
    height: 6.37,
    transform: "translate(597.28 499.7) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-94"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-94",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--terms-and-conditions--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.64,148.23H262.92s-27.15,25-27.15,85.78c0,52.27,20.59,123.14,12.86,152.15-5.83,21.89-34.1,25.65-47.65,26.17H344.44s47.18,2.85,54.91-26.17S386.49,286.28,386.49,234C386.49,173.19,413.64,148.23,413.64,148.23Z",
    style: {
      fill: "#54AFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.64,148.23H262.92s-27.15,25-27.15,85.78c0,52.27,20.59,123.14,12.86,152.15-5.83,21.89-34.1,25.65-47.65,26.17H344.44s47.18,2.85,54.91-26.17S386.49,286.28,386.49,234C386.49,173.19,413.64,148.23,413.64,148.23Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.64,212.33H252.1c3.41-26.74,12.6-42.3,17.67-49.1H386C380.3,175.13,374.92,191.34,372.64,212.33Z",
    style: {
      fill: "#54AFFF",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.63,226.51H250.92c.1-2.43.24-4.79.44-7.07H372Q371.75,222.89,371.63,226.51Z",
    style: {
      fill: "#54AFFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.77,240.68H250.88q-.1-3.39-.11-6.67v-.39h37.9V234C288.67,236.21,288.7,238.44,288.77,240.68Z",
    style: {
      fill: "#54AFFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.35,254.85H251.73c-.21-2.38-.38-4.74-.51-7.06H371.89Q372.07,251.3,372.35,254.85Z",
    style: {
      fill: "#54AFFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.68,269H253.16q-.42-3.55-.78-7.07H373C373.17,264.31,373.42,266.67,373.68,269Z",
    style: {
      fill: "#54AFFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.42,283.2H255c-.33-2.36-.64-4.72-.94-7.06H374.52Q374.94,279.67,375.42,283.2Z",
    style: {
      fill: "#54AFFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.41,297.37H257q-.52-3.54-1-7.06H376.4C376.73,292.66,377.07,295,377.41,297.37Z",
    style: {
      fill: "#54AFFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.54,311.55H259.17c-.19-1.29-.39-2.6-.59-3.91l-.48-3.16H378.47C378.83,306.84,379.18,309.2,379.54,311.55Z",
    style: {
      fill: "#54AFFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.27,325.72q-.5-3.5-1-7.06H380.62c.35,2.36.71,4.71,1.05,7.06Z",
    style: {
      fill: "#54AFFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.18,339.89c-.28-2.31-.59-4.67-.91-7.06h100.4c.34,2.38.66,4.74,1,7.06Z",
    style: {
      fill: "#54AFFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.66,354.07q-.29-3.46-.66-7.07H384.52c.27,2.42.52,4.78.73,7.07Z",
    style: {
      fill: "#54AFFF",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.35,368.24c0-2.28-.09-4.64-.22-7.06h63.59c.16,2.47.25,4.83.28,7.06Z",
    style: {
      fill: "#54AFFF",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M356,404.68c-7.65,1.39-15.4.33-23.09,0a61,61,0,0,0-11.06.29c-3.6.48-7.18,1.42-10.81,1.1a19.62,19.62,0,0,0,3.37-2.29.37.37,0,0,0-.16-.62c-11.29-4-21.57,6.82-32.82,4.3,3.19-2.36,7.68-2.41,10.4-5.51a.38.38,0,0,0-.27-.64C281.5,401.11,272,405,262,405.89c-.48,0-.48.79,0,.75,9.65-.84,18.9-4.53,28.63-4.61-2.91,2.6-7.35,2.69-10.31,5.31a.38.38,0,0,0,.16.63c11.34,3.13,21.66-7.69,32.86-4.35a18.84,18.84,0,0,1-3.79,2.31.38.38,0,0,0,.09.69c3.69.62,7.3-.17,10.94-.75a59.61,59.61,0,0,1,12.31-.48c7.77.37,15.57,1.42,23.29,0C356.69,405.32,356.49,404.59,356,404.68Z",
    style: {
      fill: "#54AFFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.88,185.13c.63.81,1.44,1.76,2.18,2.64s1.55,1.77,2.35,2.63c1.61,1.72,3.24,3.41,5,5a45.3,45.3,0,0,0,11,7.7c.49.22,1,.42,1.45.6a6.84,6.84,0,0,0,.68.23,3.58,3.58,0,0,0,.66.19,15.48,15.48,0,0,0,2.93.46,31.36,31.36,0,0,0,6.62-.38,61.34,61.34,0,0,0,6.89-1.46c2.3-.6,4.65-1.34,6.84-2.11l2,4a56,56,0,0,1-14.3,6.36,34.62,34.62,0,0,1-8.16,1.31,21.39,21.39,0,0,1-4.47-.29c-.38-.06-.77-.15-1.15-.24s-.78-.19-1.11-.3c-.7-.21-1.38-.44-2-.7A47.14,47.14,0,0,1,155.45,202a75.07,75.07,0,0,1-5.67-5.46c-.89-1-1.76-1.93-2.6-2.93s-1.64-2-2.51-3.15Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.71,182.3c-.22,5.6,2,15.7,2,15.7l13.86-1.68s.51-14.78-2.18-18.35C150.84,172,141.92,177,141.71,182.3Z",
    style: {
      fill: "#54AFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.62,202.05l6.49-5.94.83,6.4s-2.69,3.61-5.74,2.09Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.37 196.46 209.12 200.06 203.94 202.51 203.11 196.11 206.37 196.46",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.73,180.27c.69,0,1.07,0,1.56,0a4.58,4.58,0,0,1,.63,0l.52.07a2.6,2.6,0,0,1,1.24.49,1.52,1.52,0,0,1,.34.73l.23.76.93,3,1.86,6.07,3.71,12.15c2.45,8.1,5,16.18,7.36,24.3,4.85,16.22,9.44,32.5,13.95,48.81s8.75,32.69,13.11,49,8.26,32.81,9.65,49.93a5,5,0,0,1-9.47,2.45c-7.1-15.64-11.74-31.91-15.8-48.33S226.18,297,222.2,280.59s-7.87-32.91-11.51-49.44c-1.87-8.25-3.57-16.55-5.36-24.82l-2.65-12.42-1.33-6.21-.66-3.11-.17-.77a1.57,1.57,0,0,1-.06-.81,2.72,2.72,0,0,1,.84-1l.43-.32a4.29,4.29,0,0,1,.52-.34c.43-.25.74-.46,1.36-.76A3,3,0,0,1,204.73,180.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.86,378.16a1.07,1.07,0,0,0-1.3-.75l-2.2.57-2.2.57a1.07,1.07,0,0,0-.77,1.29c1.37,6.3,0,10.81,1.46,16.35,1.51,5.83,8.08,8.82,8.08,8.82l-.21-2.49,1,2.28s4.29-5.8,2.78-11.63C264.08,387.63,260.72,384.33,258.86,378.16Z",
    style: {
      fill: "#54AFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.86,378.16a1.07,1.07,0,0,0-1.3-.75l-2.2.57-2.2.57a1.07,1.07,0,0,0-.77,1.29c1.37,6.3,0,10.81,1.46,16.35,1.51,5.83,8.08,8.82,8.08,8.82l-.21-2.49,1,2.28s4.29-5.8,2.78-11.63C264.08,387.63,260.72,384.33,258.86,378.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.57,392.62a1.37,1.37,0,1,1-1.67-1A1.38,1.38,0,0,1,260.57,392.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.8,402.82a.3.3,0,0,1-.38-.22l-2.48-9.55a.31.31,0,0,1,.22-.38.3.3,0,0,1,.38.22l2.48,9.55A.31.31,0,0,1,261.8,402.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.7,343.82l-13.48,3.49a1.46,1.46,0,0,1-1.77-1.05h0a1.46,1.46,0,0,1,1-1.77L253,341a1.46,1.46,0,0,1,1.77,1h0A1.47,1.47,0,0,1,253.7,343.82Z",
    style: {
      fill: "#54AFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.27,160.8c-.24.6-.11,1.23.28,1.4s.91-.18,1.15-.78.12-1.23-.28-1.4S185.52,160.2,185.27,160.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.24,160l1.61.21S186.65,161,186.24,160Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.55,161.6a17.87,17.87,0,0,0,.6,4.77,2.79,2.79,0,0,1-2.3-.53Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.69,157.14a.38.38,0,0,1-.17-.08,3.17,3.17,0,0,0-2.7-.78.39.39,0,0,1-.47-.27.39.39,0,0,1,.27-.47,3.93,3.93,0,0,1,3.4.94.38.38,0,0,1,0,.54A.37.37,0,0,1,187.69,157.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.07,160.49c.43,4.87-1.19,12.84-4.87,15.55,0,0,2.77,5.12,11.64,6.31,9.75,1.31,5.17-4.18,5.17-4.18-5.19-2-4.63-5.87-3.32-9.43Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.64,186.48c.77,4.54,1.72,9.25,2.71,13.84.53,2.29,1.06,4.59,1.68,6.84s1.24,4.5,1.93,6.71c.38,1.09.72,2.2,1.12,3.26l.6,1.6.14.39,0,.12a1.71,1.71,0,0,0,.07.18,1.58,1.58,0,0,0,.94.73,8.2,8.2,0,0,0,2.46.47,29.61,29.61,0,0,0,6.4-.52c2.21-.4,4.54-.94,6.71-1.54l1.83,4.05a38.44,38.44,0,0,1-3.4,1.8,35.61,35.61,0,0,1-3.53,1.5,29.5,29.5,0,0,1-7.85,1.88,15,15,0,0,1-4.72-.32,9.49,9.49,0,0,1-5.09-3.07,9.77,9.77,0,0,1-.92-1.32c-.14-.23-.25-.47-.37-.7l-.19-.45-.78-1.75c-.51-1.17-1-2.34-1.43-3.52-.86-2.36-1.68-4.73-2.39-7.11s-1.35-4.78-2-7.18c-1.19-4.82-2.16-9.59-2.88-14.58Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.44,218.84l3.86-3.06,1.74,5.94s-5.28,3.82-6.69-.67Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.79 216.83 223.17 221.17 220.04 221.72 218.31 215.78 221.79 216.83",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.67 407.41 157.74 408.01 160.13 389.48 152.06 388.88 149.67 407.41",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.99 383.87 104.98 388.12 116.61 373.6 109.62 369.35 97.99 383.87",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.86,390.26a1,1,0,0,1-.3,0c-1,0-2.19-1.56-2.79-2.48a.18.18,0,0,1,0-.21.19.19,0,0,1,.19-.09c.33.07,3.22.68,3.6,1.64a.65.65,0,0,1-.1.64A1.13,1.13,0,0,1,109.86,390.26Zm-2.5-2.27c.85,1.2,1.66,1.91,2.21,1.92a.67.67,0,0,0,.59-.34.26.26,0,0,0,0-.28C110,388.78,108.51,388.27,107.36,388Z",
    style: {
      fill: "#54AFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.43,387.76a6,6,0,0,1-2.55.13.2.2,0,0,1-.13-.14.18.18,0,0,1,0-.18c.06-.07,1.65-1.7,2.82-1.65a1,1,0,0,1,.78.39.67.67,0,0,1,.1.83A1.9,1.9,0,0,1,109.43,387.76Zm-2.1-.18c1,.11,2.54-.18,2.85-.64,0-.08.08-.19-.08-.39a.64.64,0,0,0-.5-.25A4.29,4.29,0,0,0,107.33,387.58Z",
    style: {
      fill: "#54AFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.08,386.56l-6.63-6.38a.64.64,0,0,0-.85-.06l-5.66,4.36a1.29,1.29,0,0,0,0,1.93c2.35,2.19,3.59,3.13,6.5,5.94,1.8,1.73,4.24,4.43,6.72,6.82s4.9.13,4.08-1.08c-3.7-5.42-3.15-7.45-3.48-10.22A2.22,2.22,0,0,0,107.08,386.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.24,408.27a13.46,13.46,0,0,1-2.54-.29.19.19,0,0,1-.15-.16.2.2,0,0,1,.1-.2c.37-.19,3.65-1.84,4.61-1.28a.57.57,0,0,1,.31.5,1.05,1.05,0,0,1-.37.93A3.07,3.07,0,0,1,161.24,408.27Zm-1.9-.56c1.78.29,3.11.22,3.61-.22a.7.7,0,0,0,.24-.62.21.21,0,0,0-.11-.2C162.54,406.37,160.69,407.07,159.34,407.71Z",
    style: {
      fill: "#54AFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.74,408a.2.2,0,0,1-.11,0,.18.18,0,0,1-.08-.18c0-.14.39-3.44,2.2-3.44h.15c.53.05.68.31.71.53.15.91-1.81,2.66-2.79,3.1Zm2-3.27c-1.16,0-1.62,1.92-1.76,2.74,1-.6,2.33-2,2.24-2.52,0-.05,0-.18-.37-.21Z",
    style: {
      fill: "#54AFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.24,406.86h-9.07a.67.67,0,0,0-.66.55l-1.22,7.17a1.27,1.27,0,0,0,1.26,1.44c3.16,0,4.69-.24,8.68-.24,2.45,0,7.52.25,10.91.25s3.66-3.35,2.25-3.65c-6.29-1.36-8.73-3.24-10.81-5A2.09,2.09,0,0,0,158.24,406.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.13 389.48 158.8 399.78 150.82 398.44 152.06 388.89 160.13 389.48",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.61 369.35 116.61 373.61 111.79 379.61 104.65 375.54 109.61 369.35",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.6,224.66l32.67,4.39C190.93,183.23,187.2,182,187.2,182a33.16,33.16,0,0,0-4.45-1.74q-2.31-.84-4.67-1.53a82.49,82.49,0,0,0-9.57-2.23,83.63,83.63,0,0,0-19-1.07,4.24,4.24,0,0,0-3.2,1.83,3.79,3.79,0,0,0-.35.62,4.56,4.56,0,0,0-.4,2.44C148.32,204.4,147.43,212.32,145.6,224.66Z",
    style: {
      fill: "#54AFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.45,196a27.38,27.38,0,0,0,1.77,14c2.17-8.94,3.35-15,3.93-19.2C184.66,190.69,182.07,191.65,181.45,196Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.91,181.84c5.6,3.2,9.49,10.83,10.66,15.26L185.65,208s-6.18-14.37-5.68-18.83S184.8,180.63,186.91,181.84Z",
    style: {
      fill: "#54AFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.84,150.44c-2.51,7.58-3.73,10.73-1.53,16.13,3.32,8.13,13.15,9.85,17.87,3.24,4.25-5.95,7.64-17.35,1.59-23.41A10.67,10.67,0,0,0,165.84,150.44Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.27,157.16a7.2,7.2,0,0,0-.24,4.35c.5,2,2,2.17,2.93.88s1.56-3.62.56-5.3S178.92,155.63,178.27,157.16Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56,141c-5.4-3-15.12,5.78-17.56,20.11-1.75,10.26,20.16,15.22,34,15.06-.92-2.42-6.67-9.7-3-16.71,2.67-5.09,5.71-3.91,5.91-9.83C188.16,142.17,178.28,137.17,168.56,141Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85,144.22c6.28-.61,12.59,5.56,7.91,11.71a10,10,0,0,0-8.24-2C177.65,154.57,180.85,144.22,180.85,144.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.65,227.89S157,281.51,151,312.32c-6.26,32.5-36.27,66.36-36.27,66.36L104.57,373s18.88-30.9,25-61.25c12.44-61.6,4-74,16-87.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.77 379.63 103.04 372.54 104.9 368.78 119.18 375.35 115.77 379.63",
    style: {
      fill: "#54AFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.9,239.54c-9.86,8.57-8.79,39-7.76,52.66,4.14-19.48,9.11-41.16,12-53.71C166.13,237.71,164.72,238,162.9,239.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.79,229.07s5.71,63.67,2.59,87.95c-3.24,25.26-19.72,80.21-19.72,80.21L149,395.73s9.46-54.46,11.14-79.46c1.83-27.27-6.3-90.41-6.3-90.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.13 397.9 146.55 395.76 146.8 390.86 164.8 392.6 163.13 397.9",
    style: {
      fill: "#54AFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.31,222.69l-1.78,2.71c-.14.21.11.47.48.52l34.27,4.6c.3,0,.56-.07.59-.25l.61-2.86c0-.2-.2-.41-.52-.45l-33.09-4.44A.61.61,0,0,0,145.31,222.69Z",
    style: {
      fill: "#54AFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.31,222.69l-1.78,2.71c-.14.21.11.47.48.52l34.27,4.6c.3,0,.56-.07.59-.25l.61-2.86c0-.2-.2-.41-.52-.45l-33.09-4.44A.61.61,0,0,0,145.31,222.69Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.37,227l-.89-.12c-.18,0-.3-.13-.28-.24l.82-3.72c0-.1.19-.17.36-.15l.89.12c.18,0,.3.13.28.24l-.82,3.72C149.71,226.91,149.54,227,149.37,227Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.75,230l-.89-.12c-.17,0-.3-.13-.28-.24l.82-3.72c0-.11.19-.18.37-.15l.88.11c.18,0,.3.14.28.25l-.82,3.71C172.09,230,171.92,230,171.75,230Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.2479215b74df905e12f84bfc87fe08fb.svg";
export { ForwardRef as ReactComponent };